'use strict'

const app = angular.module('rmItemPlanner')

app.config(['$stateProvider', function ($stateProvider) {

    async function createBladeIfNotExists (bladesManager, options, level = 0) {
        if (!bladesManager.all(level).some(el => el.viewName === options.viewName)) {
            await bladesManager.insertRight(options, level)
        }
    }

    const openItemState = {
        url: '/item/create?blockId&afterItemId&createInDate',
        views: {
            'item-planner-item_form@': {
                templateUrl: '/partial/app.partials.item-planner.item_detail',
                controller: 'ItemPlannerItemFormCtrl',
                controllerAs: 'ctrl'
            }
        },
        onEnter: ['bladesManager', '$rootScope', function (bladesManager, $rootScope) {

            $rootScope.bladeManagerOnTop = true
            let loadedViews = bladesManager.all()

            let found = loadedViews.some(function (el) {
                return el.viewName === 'item-planner-item_form'
            })
            if (!found) {
                bladesManager.insert({
                    viewName: 'item-planner-item_form',
                    size: 'full-one-third',
                    extraClasses: 'item-planner'
                }, 1)
            }

        }],
        onExit: ['bladesManager', '$state', '$rootScope', function (bladesManager, $state, $rootScope) {
            $rootScope.bladeManagerOnTop = false

            if (!$state.includes('item.create')) {
                bladesManager.removeRight('item-planner-item_form', 1)
            }
        }]
    }

    const createCampaignState = {
        url: '/create',
        views: {
            'item-planner-campaign_form@': {
                templateUrl: '/partial/app.partials.item-planner.campaign_form',
                controller: 'ItemPlannerCampaignFormCtrl',
                controllerAs: 'ctrl'
            }
        },
        onEnter: ['bladesManager', '$rootScope', function (bladesManager, $rootScope) {

            $rootScope.bladeManagerOnTop = true
            let loadedViews = bladesManager.all()

            let found = loadedViews.some(function (el) {
                return el.viewName === 'item-planner-campaign_form'
            })
            if (!found) {
                bladesManager.insert({
                    viewName: 'item-planner-campaign_form',
                    size: 'full-one-third',
                    extraClasses: 'item-planner'
                }, 1)
            }

        }],
        onExit: ['bladesManager', '$state', '$rootScope', function (bladesManager, $state, $rootScope) {
            $rootScope.bladeManagerOnTop = false

            if (!$state.includes('create')) {
                bladesManager.removeRight('item-planner-campaign_form', 1)
            }
        }]
    }

    const updateCampaignState = {
        url: '/update/:id',
        views: {
            'item-planner-campaign_form@': {
                templateUrl: '/partial/app.partials.item-planner.campaign_form',
                controller: 'ItemPlannerCampaignFormCtrl',
                controllerAs: 'ctrl'
            }
        },
        onEnter: ['bladesManager', '$rootScope', function (bladesManager, $rootScope) {

            $rootScope.bladeManagerOnTop = true
            let loadedViews = bladesManager.all()

            let found = loadedViews.some(function (el) {
                return el.viewName === 'item-planner-campaign_form'
            })
            if (!found) {
                bladesManager.insert({
                    viewName: 'item-planner-campaign_form',
                    size: 'full-one-third',
                    extraClasses: 'item-planner'
                }, 1)
            }

        }],
        onExit: ['bladesManager', '$state', '$rootScope', function (bladesManager, $state, $rootScope) {
            $rootScope.bladeManagerOnTop = false

            if (!$state.includes('update')) {
                bladesManager.removeRight('item-planner-campaign_form', 1)
            }
        }]
    }

    const openContactState = {
        url: '/contact/:contactId',
        params: {
            create: false
        },
        views: {
            'contact@': {
                templateUrl: '/partial/app.partials.contact.detail',
                controller: 'ContactFormCtrl',
                controllerAs: 'contactCtrl',
            },
        },
        onEnter: ['bladesManager', async bladesManager => {
            await createBladeIfNotExists(bladesManager, {
                viewName: 'item-planner-item_form',
                size: 'full-one-third'
            }, 1)
            await createBladeIfNotExists(bladesManager, { viewName: 'contact', size: 'one-third' }, 1)
        }],

        onExit: ['$state', '$stateParams', 'Contact', 'bladesManager', ($state, $stateParams, Contact, bladesManager) => {
            let contact = Contact.get({ id: $stateParams.contactId }, () => {
                let contactHasProbablyBeenSaved = contact.firstname && contact.lastname
                if ($stateParams.create === true && !contactHasProbablyBeenSaved) {
                    Contact.delete({ id: $stateParams.contactId })
                }
            })

            if (!$state.includes('contact')) {
                bladesManager.removeRight('contact', 1)
            }
        }]
    }

    $stateProvider
        .state('item-planner', {
            url: '/item-planner?date',
            views: {
                'item-planner': {
                    templateUrl: '/partial/app.partials.item-planner.overview',
                    controller: 'ItemPlannerOverviewCtrl',
                    controllerAs: 'ctrl'
                },
            },

            onEnter: ['bladesManager', function (bladesManager) {
                bladesManager.clearAll()
                bladesManager.insert({ viewName: 'item-planner', size: 'full' })
            }],

            resolve: {

                itemFilters: ['$http', function ($http) {

                    return $http.get('/usersettings').then((req) => {

                        return req.data.item_filter
                    })
                }],

                filterMap: ['$http', function ($http) {

                    return $http.get('/userfilters/campaign').then((req) => {

                        return req.data.userFilters
                    })
                }]
            }
        })
        .state('item-planner.create', createCampaignState)
        .state('item-planner.update', updateCampaignState)
        .state('item-planner.item-create', angular.copy(openItemState))
        .state('item-planner.item-update', {
            ...angular.copy(openItemState),
            url: '/item/update/:itemId',
        })
        .state('item-planner.item-create.contact', angular.copy(openContactState))
        .state('item-planner.item-update.contact', angular.copy(openContactState))


}])
